import React from 'react';

import _ from '../locale';
import SubmitModal, { Props as SubmitModalProps } from './SubmitModal';

export type Props = {
    message: string;
} & SubmitModalProps;

const AlertModal: React.FC<Props> = (props: Props) => {
    const { message, ...restProps } = props;

    return (
        <SubmitModal isCancelEnabled={false} {...restProps}>
            {message}
        </SubmitModal>
    );
};

export default AlertModal;
